import { render, staticRenderFns } from "./IconTrash.vue?vue&type=template&id=83f3f782"
import script from "./IconTrash.vue?vue&type=script&lang=js"
export * from "./IconTrash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports